export default {
  labels: {
    in_store_card_payments_not_supported: '⚠️ Tylko gotówka w restauracji. Płatność kartą niedostępna.',
  },
};
